import { DatePipe } from '@angular/common';
import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PublicationService } from '../services/publication/publication.service';
import { PublicationModel } from '../shared/model/publication.model';
import { SearchPublicationHistoryModel } from '../shared/model/SearchPublicationHistory.model';
import { PublicationHistoryService } from '../services/publication-history/publication-history.service';
import { PublicationHistoryItem } from '../services/publication-history/PagedPublicationHistoryList';
import { PageSizeList } from '../services/PageSizeList';
import { BaseComponent } from '../base/base.component';
import { AttachmentsModalComponent } from '../attachments-modal/attachments-modal.component';
import { UserRegistrationService } from '../services/user-registration/user-registration.service';
import { UserModel } from '../services/user/UserModel';
import { IAppConfig } from '../services/Config/app-config.model';
import { SubmittalService } from '../services/submittal/submittal.service';
import { PublicationPDFService } from '../services/publication-pdf/publication-pdf.service'
import { AttachmentsBaseComponent, Action } from '../attachment-base/attachment-base.component';
import { interval } from 'rxjs';

const ConstProjectSubmitted = 'ProjSubmitted';
const ConstENF = 'ENF';
const ConstEIR = 'EIR';
const ConstSRPR = 'SRPR';
const ConstENFSiteVisits = 'ENFSiteVisits';
const ConstNPC = 'NPC';
const ConstProjectsUnderReview = 'ProjUnderRev';
const ConstCert = 'SecretaryCert';
const ConstROD = 'ROD';
const ConstSRP = 'SRP';
const ConstPBN = 'PBN';
const ConstAO = 'AO';
const ConstRequestAO = 'RequestAO';
const ConstPublicNotices = 'PublicNotices';

const PageSizeDefaultIndex = 2;
@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.css']
})
export class PublicationsComponent extends BaseComponent implements OnInit {

  private route: ActivatedRoute;
  publicationService: PublicationService;
  publication: PublicationModel;
  setPublicationLabel = false;
  publicationLabel = ''
  private datePipe: DatePipe;
  private publicationHistoryService: PublicationHistoryService;
  environmentalNotificationForms: PublicationHistoryItem[] = [];
  environmentalImpactReports: PublicationHistoryItem[] = [];
  ENFSiteVisits: PublicationHistoryItem[] = [];
  npc: PublicationHistoryItem[] = [];
  srpr: PublicationHistoryItem[] = [];
  projectsUnderReviewENF: PublicationHistoryItem[] = [];
  projectsUnderReviewEIR: PublicationHistoryItem[] = [];
  projectsUnderReviewNPC: PublicationHistoryItem[] = [];
  projectsUnderReviewSRPR: PublicationHistoryItem[] = [];
  certENF: PublicationHistoryItem[] = [];
  certEIR: PublicationHistoryItem[] = [];
  certNPC: PublicationHistoryItem[] = [];
  certROD: PublicationHistoryItem[] = [];
  certSRP: PublicationHistoryItem[] = [];
  certPBN: PublicationHistoryItem[] = [];
  certAO: PublicationHistoryItem[] = [];
  requestAO: PublicationHistoryItem[] = [];
  publicNotices: PublicationHistoryItem[] = [];

  pageSize = 10;
  pageSizeList: Array<number>;

  private _inputPublishingId: string;
  totalItems: number;
  currentPage: number = 1;
  currentTab: string;
  totalEIRItems: number;
  currentEIRPage: number;
  totalENFItems: number;
  currentENFPage: number;
  currentENFSiteVisitsPage: number;
  totalENFSiteVisitsItems: number;
  currentNPCPage: number;
  currentSRPRPage: number;
  totalNPCItems: number;
  totalSRPRItems: number;
  currentPURENFPage: number;
  totalPURENFItems: number;
  currentPUREIRPage: number;
  currentPURSRPRPage: number;
  totalPUREIRItems: number;
  currentPURNPCPage: number;
  totalPURNPCItems: number;
  totalPURSRPRItems: number;
  currentCertENFPage: number;
  totalCertENFItems: number;
  currentCertEIRPage: number;
  totalCertEIRItems: number;
  currentCertNPCPage: number;
  totalCertNPCItems: number;
  currentCertRODPage: number;
  totalCertRODItems: number;
  currentCertSRPPage: number;
  totalCertSRPItems: number;
  currentCertPBNPage: number;
  totalCertPBNItems: number;
  currentCertAOPage: number;
  totalCertAOItems: number;
  currentRequestAOPage: number;
  totalRequestAOItems: number;
  currentPublicNoticesPage: number;
  totalPublicNoticesItems: number;
  userRegistrationService: UserRegistrationService;
  userModel: UserModel;
  public tabIndex = new Array(true, false, false, false, false, false);
  public tabIndexNewProjects = new Array(true, false, false, false);
  public tabIndexProjectsUnderReview = new Array(true, false, false, false);
  public tabIndexCertificates = new Array(true, false, false, false, false, false);
  public tabIndexAdvisoryOpinion = new Array(true, false);
  public recentDecisonsUrl: string;
  @Input() set inputPublishingId(value: string) {
    this._inputPublishingId = value;
    this.GetPublication();
    this.NewProjectsClick();
  }
  publicationPDFService: PublicationPDFService;
  public attachmentsBaseComponent: AttachmentsBaseComponent;

  SetActiveTab(toActivate: number, tabs: Array<boolean>) {
    for (var index = 0; index < tabs.length; index++) {
      if (index == toActivate)
        tabs[index] = true;
      else {
        tabs[index] = false;
      }
    }
  }

  NewProjectsClick() {
    this.SetActiveTab(0, this.tabIndex);
    this.LoadProjectsSubmittedENF();
  }

  ProjectsUnderReviewClick() {
    this.SetActiveTab(2, this.tabIndex);
    this.LoadENFReview();
  }

  CertificatesClick() {
    this.SetActiveTab(3, this.tabIndex);
    this.LoadENFCert();
  }

  AdvisoryOpinionClick() {
    this.SetActiveTab(4, this.tabIndex);
    this.LoadAORequest();
  }

  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig, private submittalService: SubmittalService) {
    super(_injector);
    this.route = this._injector.get(ActivatedRoute);
    this.publicationService = this._injector.get(PublicationService);
    this.datePipe = this._injector.get(DatePipe);
    this.publicationHistoryService = this._injector.get(PublicationHistoryService);
    this.userRegistrationService = this._injector.get(UserRegistrationService);
    this.recentDecisonsUrl = `${this.configParam.ApiConfig.RECENT_DECISIONS_URL}`;
    this.publicationPDFService = this._injector.get(PublicationPDFService);
    this.attachmentsBaseComponent = this._injector.get(AttachmentsBaseComponent);
  }

  GetPublication() {
    this.CleanPublicationHistories();
    if (this._inputPublishingId != undefined)
      this.publicationService.getPublication(this._inputPublishingId).subscribe(publication => {
        this.publication = publication;
        if (this.setPublicationLabel == true) {
          var transformDate = this.publication.publishDate != undefined ? this.datePipe.transform(this.publication.publishDate, 'MMM d, y') : '';
          this.publicationLabel = 'Publication: ' + transformDate +
            ', Volume ' + this.publication.volumeNumber +
            ', Issue ' + this.publication.issueNumber
        }
      });
  }

  CleanPublicationHistories() {
    this.environmentalNotificationForms = [];
    this.environmentalImpactReports = [];
    this.ENFSiteVisits = [];
    this.npc = [];
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.pageSizeList = PageSizeList.getPageSizeList();
    if (this.route.snapshot.paramMap.has('id')) {
      this._inputPublishingId = this.route.snapshot.paramMap.get('id');
      this.GetPublication();
      this.NewProjectsClick();
      this.setPublicationLabel = true;
    }
    this.pageSize = PageSizeList.getPageSizeList()[PageSizeDefaultIndex];
    this.userModel = new UserModel();
    this.userModel.ApiToken = 'anonymous' + this.configParam.ApiConfig.PUBLIC_COMMENT_APP_TOKEN;
    this.userModel.UserName = 'anonymous' + this.configParam.ApiConfig.PUBLIC_COMMENT_APP_TOKEN;
    this.userModel.Role = 'Public User';
  }

  LoadCurrentTab() {
    if (this.currentTab == ConstProjectSubmitted + ConstENF) {
      this.currentENFPage = this.currentPage;
      this.environmentalNotificationForms.splice(0, this.environmentalNotificationForms.length);
      this.LoadProjectsSubmittedENF();
    }
    if (this.currentTab == ConstProjectSubmitted + ConstEIR) {
      this.currentEIRPage = this.currentPage;
      this.environmentalImpactReports = [];
      this.LoadEIR();
    }
    if (this.currentTab == ConstProjectSubmitted + ConstENFSiteVisits) {
      this.currentENFSiteVisitsPage = this.currentPage;
      this.ENFSiteVisits = [];
      this.LoadProjectsSubmittedENFSiteVisits();
    }
    if (this.currentTab == ConstProjectSubmitted + ConstNPC) {
      this.currentNPCPage = this.currentPage;
      this.npc = [];
      this.LoadNPC();
    }
    if (this.currentTab == ConstProjectSubmitted + ConstSRPR) {
      this.currentSRPRPage = this.currentPage;
      this.srpr = [];
      this.LoadSRPR();
    }
    if (this.currentTab == ConstProjectsUnderReview + ConstENF) {
      this.currentPURENFPage = this.currentPage;
      this.projectsUnderReviewENF = [];
      this.LoadENFReview();
    }
    if (this.currentTab == ConstProjectsUnderReview + ConstEIR) {
      this.currentPUREIRPage = this.currentPage;
      this.projectsUnderReviewEIR = [];
      this.LoadEIRReview();
    }
    if (this.currentTab == ConstProjectsUnderReview + ConstNPC) {
      this.currentPUREIRPage = this.currentPage;
      this.projectsUnderReviewNPC = [];
      this.LoadNPCReview();
    }
    if (this.currentTab == ConstProjectsUnderReview + ConstSRPR) {
      this.currentPURSRPRPage = this.currentPage;
      this.projectsUnderReviewSRPR = [];
      this.LoadSRPRReview();
    }
    if (this.currentTab == ConstCert + ConstENF) {
      this.currentCertENFPage = this.currentPage;
      this.certENF = [];
      this.LoadENFCert();
    }
    if (this.currentTab == ConstCert + ConstEIR) {
      this.currentCertEIRPage = this.currentPage;
      this.certEIR = [];
      this.LoadEIRCert();
    }
    if (this.currentTab == ConstCert + ConstNPC) {
      this.currentCertNPCPage = this.currentPage;
      this.certNPC = [];
      this.LoadNPCCert();
    }
    if (this.currentTab == ConstCert + ConstROD) {
      this.currentCertRODPage = this.currentPage;
      this.certROD = [];
      this.LoadRODCert();
    }
    if (this.currentTab == ConstCert + ConstSRP) {
      this.currentCertSRPPage = this.currentPage;
      this.certSRP = [];
      this.LoadSRPCert();
    }
    if (this.currentTab == ConstCert + ConstPBN) {
      this.currentCertPBNPage = this.currentPage;
      this.certPBN = [];
      this.LoadPBNCert();
    }
    if (this.currentTab == ConstCert + ConstAO) {
      this.currentCertAOPage = this.currentPage;
      this.certAO = [];
      this.LoadAOCert();
    }
    if (this.currentTab == ConstRequestAO) {
      this.currentCertAOPage = this.currentPage;
      this.certAO = [];
      this.LoadAORequest();
    }
    if (this.currentTab == ConstPublicNotices) {
      this.currentPublicNoticesPage = this.currentPage;
      this.publicNotices = [];
      this.LoadPublicNotices();
    }
  }

  LoadNPC() {
    this.SetActiveTab(2, this.tabIndexNewProjects)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectSubmitted, ConstNPC,
      this.pageSize, this.currentNPCPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalNPCItems = publications.totalRecords;
      this.currentNPCPage = publications.currentPage;
      this.npc = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.npc);
      this.totalItems = this.totalNPCItems;
      this.currentPage = this.currentNPCPage;
      this.currentTab = ConstProjectSubmitted + ConstNPC;
    });
  }

  LoadSRPR() {
    this.SetActiveTab(3, this.tabIndexNewProjects)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectSubmitted, ConstSRPR,
      this.pageSize, this.currentSRPRPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalSRPRItems = publications.totalRecords;
      this.currentSRPRPage = publications.currentPage;
      this.srpr = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.srpr);
      this.totalItems = this.totalSRPRItems;
      this.currentPage = this.currentSRPRPage;
      this.currentTab = ConstProjectSubmitted + ConstSRPR;
    });
  }

  LoadProjectsSubmittedENF() {
    this.SetActiveTab(0, this.tabIndexNewProjects);
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectSubmitted, ConstENF,
      this.pageSize, this.currentENFPage, null);
    if (searchModel.publishingId != undefined)
      this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
        this.totalENFItems = publications.totalRecords;
        this.currentENFPage = publications.currentPage;
        this.environmentalNotificationForms = publications.list;
        this.ReplaceCopiesAnalystCommaToNewLine(this.environmentalNotificationForms);
        this.totalItems = this.totalENFItems;
        this.currentPage = this.currentENFPage;
        this.currentTab = ConstProjectSubmitted + ConstENF;
      });
  }

  private ReplaceCopiesAnalystCommaToNewLine(publicationHistoryItem: PublicationHistoryItem[]) {
    publicationHistoryItem.forEach(enf => {
      enf.forCopies = enf.forCopies.replaceAll(', N/A', '<br>');
      enf.mepaAnalyst = enf.mepaAnalyst.replaceAll(', N/A', '<br>');
    });
  }

  LoadProjectsSubmittedENFSiteVisits() {
    this.SetActiveTab(1, this.tabIndex)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectSubmitted, ConstENFSiteVisits,
      this.pageSize, this.currentENFSiteVisitsPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalENFSiteVisitsItems = publications.totalRecords;
      this.currentENFSiteVisitsPage = publications.currentPage;
      this.ENFSiteVisits = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.ENFSiteVisits);
      this.totalItems = this.totalENFSiteVisitsItems;
      this.currentPage = this.currentENFSiteVisitsPage;
      this.currentTab = ConstProjectSubmitted + ConstENFSiteVisits;
    });
  }

  LoadEIR() {
    this.SetActiveTab(1, this.tabIndexNewProjects)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectSubmitted, ConstEIR,
      this.pageSize, this.currentEIRPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalEIRItems = publications.totalRecords;
      this.currentEIRPage = publications.currentPage;
      this.environmentalImpactReports = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.environmentalImpactReports);
      this.totalItems = this.totalEIRItems;
      this.currentPage = this.currentEIRPage;
      this.currentTab = ConstProjectSubmitted + ConstEIR;
    });
  }

  LoadENFReview() {
    this.SetActiveTab(0, this.tabIndexProjectsUnderReview)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectsUnderReview, ConstENF,
      this.pageSize, this.currentPURENFPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalPURENFItems = publications.totalRecords;
      this.currentPURENFPage = publications.currentPage;
      this.projectsUnderReviewENF = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.projectsUnderReviewENF);
      this.totalItems = this.totalPURENFItems;
      this.currentPage = this.currentPURENFPage;
      this.currentTab = ConstProjectSubmitted + ConstENF;
    });
  }

  LoadEIRReview() {
    this.SetActiveTab(1, this.tabIndexProjectsUnderReview);
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectsUnderReview, ConstEIR,
      this.pageSize, this.currentPUREIRPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalPUREIRItems = publications.totalRecords;
      this.currentPUREIRPage = publications.currentPage;
      this.projectsUnderReviewEIR = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.projectsUnderReviewEIR);
      this.totalItems = this.totalPUREIRItems;
      this.currentPage = this.currentPUREIRPage;
      this.currentTab = ConstProjectSubmitted + ConstEIR;
    });
  }

  LoadNPCReview() {
    this.SetActiveTab(2, this.tabIndexProjectsUnderReview)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectsUnderReview, ConstNPC,
      this.pageSize, this.currentPURNPCPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalPURNPCItems = publications.totalRecords;
      this.currentPURNPCPage = publications.currentPage;
      this.projectsUnderReviewNPC = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.projectsUnderReviewNPC);
      this.totalItems = this.totalPURNPCItems;
      this.currentPage = this.currentPURNPCPage;
      this.currentTab = ConstProjectSubmitted + ConstNPC;
    });
  }

  LoadSRPRReview() {
    this.SetActiveTab(3, this.tabIndexProjectsUnderReview)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstProjectsUnderReview, ConstSRPR,
      this.pageSize, this.currentPURSRPRPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalPURSRPRItems = publications.totalRecords;
      this.currentPURSRPRPage = publications.currentPage;
      this.projectsUnderReviewSRPR = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.projectsUnderReviewSRPR);
      this.totalItems = this.totalPURSRPRItems;
      this.currentPage = this.currentPURSRPRPage;
      this.currentTab = ConstProjectSubmitted + ConstSRPR;
    });
  }

  LoadENFCert() {
    this.SetActiveTab(0, this.tabIndexCertificates)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstCert, ConstENF,
      this.pageSize, this.currentCertENFPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalCertENFItems = publications.totalRecords;
      this.currentCertENFPage = publications.currentPage;
      this.certENF = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.certENF);
      this.totalItems = this.totalCertENFItems;
      this.currentPage = this.currentCertENFPage;
      this.currentTab = ConstProjectSubmitted + ConstENF;
    });
  }

  LoadEIRCert() {
    this.SetActiveTab(1, this.tabIndexCertificates)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstCert, ConstEIR,
      this.pageSize, this.currentCertEIRPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalCertEIRItems = publications.totalRecords;
      this.currentCertEIRPage = publications.currentPage;
      this.certEIR = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.certEIR);
      this.totalItems = this.totalCertEIRItems;
      this.currentPage = this.currentCertEIRPage;
      this.currentTab = ConstProjectSubmitted + ConstEIR;
    });
  }

  LoadNPCCert() {
    this.SetActiveTab(2, this.tabIndexCertificates)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstCert, ConstNPC, this.pageSize, this.currentCertNPCPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalCertNPCItems = publications.totalRecords;
      this.currentCertNPCPage = publications.currentPage;
      this.certNPC = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.certEIR);
      this.totalItems = this.totalCertNPCItems;
      this.currentPage = this.currentCertNPCPage;
      this.currentTab = ConstProjectSubmitted + ConstNPC;
    });
  }

  LoadRODCert() {
    this.SetActiveTab(3, this.tabIndexCertificates)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstCert, ConstROD, this.pageSize, this.currentCertRODPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalCertRODItems = publications.totalRecords;
      this.currentCertRODPage = publications.currentPage;
      this.certROD = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.certROD);
      this.totalItems = this.totalCertRODItems;
      this.currentPage = this.currentCertRODPage;
      this.currentTab = ConstProjectSubmitted + ConstROD;
    });
  }

  LoadSRPCert() {
    this.SetActiveTab(4, this.tabIndexCertificates)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstCert, ConstSRP, this.pageSize, this.currentCertSRPPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalCertSRPItems = publications.totalRecords;
      this.currentCertSRPPage = publications.currentPage;
      this.certSRP = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.certSRP);
      this.totalItems = this.totalCertSRPItems;
      this.currentPage = this.currentCertSRPPage;
      this.currentTab = ConstProjectSubmitted + ConstSRP;
    });
  }

  LoadPBNCert() {
    this.SetActiveTab(5, this.tabIndexCertificates)
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstCert, ConstPBN, this.pageSize, this.currentCertPBNPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalCertPBNItems = publications.totalRecords;
      this.currentCertPBNPage = publications.currentPage;
      this.certPBN = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.certPBN);
      this.totalItems = this.totalCertPBNItems;
      this.currentPage = this.currentCertPBNPage;
      this.currentTab = ConstProjectSubmitted + ConstPBN;
    });
  }

  LoadAOCert() {
    this.SetActiveTab(1, this.tabIndexAdvisoryOpinion);
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstCert, ConstAO, this.pageSize, this.currentCertAOPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalCertAOItems = publications.totalRecords;
      this.currentCertAOPage = publications.currentPage;
      this.certAO = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.certAO);
      this.totalItems = this.totalCertAOItems;
      this.currentPage = this.currentCertAOPage;
      this.currentTab = ConstProjectSubmitted + ConstAO;
    });
  }

  LoadAORequest() {
    this.SetActiveTab(0, this.tabIndexAdvisoryOpinion);
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstRequestAO, '', this.pageSize, this.currentRequestAOPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalRequestAOItems = publications.totalRecords;
      this.currentRequestAOPage = publications.currentPage;
      this.requestAO = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.requestAO);
      this.totalItems = this.totalRequestAOItems;
      this.currentPage = this.currentRequestAOPage;
      this.currentTab = ConstRequestAO;
    });
  }

  LoadPublicNotices() {
    this.SetActiveTab(5, this.tabIndex);
    var searchModel = new SearchPublicationHistoryModel(this._inputPublishingId, ConstPublicNotices, '', this.pageSize, this.currentPublicNoticesPage, null);
    this.publicationHistoryService.GetPublicationHistoryList(searchModel).subscribe(publications => {
      this.totalPublicNoticesItems = publications.totalRecords;
      this.currentPublicNoticesPage = publications.currentPage;
      this.publicNotices = publications.list;
      this.ReplaceCopiesAnalystCommaToNewLine(this.publicNotices);
      this.totalItems = this.totalPublicNoticesItems;
      this.currentPage = this.currentPublicNoticesPage;
      this.currentTab = ConstPublicNotices;
    });
  }

  onPageSizeChange() {
    this.LoadCurrentTab();
  }

  OpenModalAttachments(publicationHistoryItem: PublicationHistoryItem) {
    const modalRef = this.dialogService.open(AttachmentsModalComponent);
    modalRef.componentInstance.publicationHistoryId = publicationHistoryItem.publicationHistoryId;
  }

  OpenFirstAttachment(publicationHistoryItem: PublicationHistoryItem) {
    this.attachmentsBaseComponent.OpenFirstAttachment(publicationHistoryItem.publicationHistoryId,
      () => { super.hideProgress() });
  }

  PageChanged(value: { page: number; }) {
    if (this.currentPage !== value.page) {
      this.currentPage = value.page;
      this.LoadCurrentTab();
    }
  }

  OpenForComment(publicationItem: PublicationHistoryItem) {
    this.userRegistrationService.GetRedirectionUrl(this.userModel).subscribe(response => {
      if (response && response.headers && response.headers.Location) {
        PublicationHistoryItem.OpenForComment(response.headers.Location, publicationItem, this.datePipe);
      }
    });
  }

  GoToSubmittal(form: any) {
    this.submittalService.setEeaNumber(form.eeaNumber);
    this.submittalService.setProjectName(form.projectName);

    this.router.navigateByUrl(`/submittal/${form.submittalId}`);
  }

  ValidateCommentsDue(publicationHistoryItem: PublicationHistoryItem): string {
    if (publicationHistoryItem.withdrawn == true) {
      return "Withdrawn";
    }
    if (this.IsNullOrUndefined(publicationHistoryItem.commentsDue)) {
      return "NA";
    }
    var { DateTime } = require('luxon');
    var dueDate = DateTime.fromISO(publicationHistoryItem.commentsDue);
    return dueDate.toFormat('MM/dd/yyyy');
  }

  DownloadPublicationPDF(publication: PublicationModel) {
    this.publicationPDFService.LoadProjectsSubmitted(
      this._inputPublishingId,
      this.datePipe.transform(
        publication.publishDate,
        "yyyy-MM-dd h:mm:ss a"
      )
    );
  }
}
